import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/salon";
import { Overline, Reveal } from "@/components/Reveal";

const Faq = () => (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-cream">
        <div className="max-w-[1100px] mx-auto px-5 md:px-10">
            <Reveal className="mb-12">
                <Overline>Domande Frequenti</Overline>
                <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-ink mt-4">
                    Quello che ci chiedono{" "}
                    <em className="italic text-sage">più spesso</em>
                </h2>
            </Reveal>

            <Reveal delay={0.1}>
                <Accordion type="single" collapsible className="w-full">
                    {FAQS.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`faq-${i}`}
                            data-testid={`faq-item-${i + 1}`}
                            className="border-linen"
                        >
                            <AccordionTrigger
                                data-testid={`faq-trigger-${i + 1}`}
                                className="font-serif text-xl md:text-2xl text-ink hover:text-rosegold hover:no-underline py-6 text-left transition-colors duration-300"
                            >
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-stone2 text-base leading-relaxed pb-6 max-w-2xl">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);

export default Faq;
